<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>
                        <b-col lg="9">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                                size="sm"></b-pagination>
                        </b-col>
                    </b-row>
                </div>
                <div class="b-table-sticky-header">
                    <b-table v-if="items.length > 0" sticky-header ref="table" stacked="lg" striped hover :items="items"
                        :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left
                        head-variant="light" class="sa-b-table">
                        <template #cell(riferimento)="row">
                            <strong style="font-size: small; display: inline-block;">
                                {{ formattaData(row.item.dataRiferimento) }}
                                <br>
                                {{ getOrario(row.item.dataOraInizio) }} - {{ getOrario(row.item.dataOraFine) }}
                            </strong>
                        </template>
                        <template #cell(agenda)="row">
                            <span style="font-size: small; display: inline-block;">
                                {{ getInfoAgenda(row.item) }}
                            </span>
                        </template>

                        <template #cell(actions)="row">
                            <b-button :disabled="row.item.statoAttuale == 'EROGATO'" variant="outline-primary"
                                @click="onChangeStatoPrenotazione(row.item)">
                                <b-icon icon="gear" aria-hidden="true"></b-icon>
                            </b-button>
                        </template>

                    </b-table>
                    <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti appuntamenti per agenda"
                        nome="no-data" subtitle="" icon="fas fa-users" />
                </div>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <b-modal ref="mdlChangeStato" @hide="onHide" title="Cambio Stato Appuntamento" hide-footer>
                <b-form>
                    <b-row>
                        <b-col cols="5">
                            <label>Stato</label>
                            <b-form-select @change="onChangeSelectStato" v-model="jsonData.orderStatus"
                                :options="orderStutusOptions"></b-form-select>
                        </b-col>
                        <b-col cols="5">
                            <label>Reason</label>
                            <b-form-select
                                :disabled="jsonData.orderStatus != 'NON_EROGATO' && jsonData.orderStatus != 'ANNULLATO'"
                                v-model="jsonData.reasonId" :options="reasonIdOptions"></b-form-select>
                        </b-col>
                        <b-col cols="2">
                            <b-container>
                                <b-button variant="outline-primary" @click="onCambiaStato()">
                                    <b-icon icon="gear" aria-hidden="true"></b-icon>
                                </b-button>
                            </b-container>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>
        </div>
    </div>
</template>

<script>
// import axios from "axios";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";
import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast.js";
import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    //PrintComponent
    mixins: [UtilityMixin],
    components: { NoDataComponent },
    data() {
        return {
            pathResource: "/accettazionessn",
            pathResourceRicette: "/accettazionericette",
            items: [],
            righeAperte: [],
            rows: 0,
            jsonData: {
                orderId: null,
                orderStatus: "EROGATO",
                reasonId: 0
            },
            filtro: {
                codiceFiscaleAssistito: null,
                idPresidio: null,
            },
            presidio: {},
            orderStutusOptions: [],
            reasonIdOptions: [],
            page: 1,
            perPage: 10000,
            signedPdfViewer: null,
            appuntamentoSel: {
                statoAttuale: ""
            },
            agendaOptions: [],
            listKey: 0,
            previewSelected: null,
            currentPage: 1,
            rowSelectedAccettazione: {},
            dataRiferimento: null,
            listaRicetteDetails: {},
            fields: [
                {
                    label: "C.F Assistito",
                    key: "identificativoAppuntamento",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                },
                {
                    label: "Agenda",
                    key: "agenda",
                },
                {
                    label: "Prestazione",
                    key: "descrizionePrestazione",
                },
                {
                    label: "Appuntamento",
                    key: "riferimento",

                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    mounted() {
        let tmpPresidio = window.localStorage.getItem("presidio");
        if (tmpPresidio) {
            let presidio = JSON.parse(tmpPresidio);
            this.presidio = presidio;
            this.loadReasonId();
            this.loadStausOrder();
            this.loadAgende()
        }
    },
    watch: {

    },
    methods: {
        init(filtro, dataRiferimento) {
            this.filtro = filtro;
            this.dataRiferimento = dataRiferimento;
            this.loadData();
        },
        formattaData(dataString) {
            if (!dataString) return '';
            // Separa l'anno, il mese e il giorno [yyyy, mm, dd]
            const parti = dataString.split('-');
            // Li riunisce al contrario: dd/mm/yyyy
            return `${parti[2]}/${parti[1]}/${parti[0]}`;
        },
        loadData() {
            this.openShowModalLoading();
            if (this.filtro.idPresidio == null) {
                toast.warning("Id Presidio Obbligatorio")
                this.closeShowModalLoading();
                return;
            }
            const oggi = moment(this.dataRiferimento).format('YYYY-MM-DD');
            console.log(oggi);

            this.filtro.dataRiferimento = oggi;

            this.loadDataResources("/agendaappuntamenti", this.filtro, this.loadDataAccettazioneSsnSuccess, this.loadDataAccettazioneSsnError);
        },

        getOrario(data) {
            return moment(data).format("HH:mm");
        },
        loadAgende() {
            let link = process.env.VUE_APP_PATH_API + "/agende";
            axios
                .get(link, { params: this.filtro })
                .then((response) => {
                    this.agendaOptions = response.data.data;

                })
                .catch((e) => {
                    console.log(e);
                });

        },
        loadDataAccettazioneSsnSuccess(response) {
            this.items = response.data.data;
            this.closeShowModalLoading();
        },
        loadDataAccettazioneSsnError(response) {
            response;
            this.closeShowModalLoading();

        },
        setData(dataRiferimento) {
            this.dataRiferimento = dataRiferimento;
            this.loadData();
        },

        getInfoAgenda(item) {
            let returnValue = "";
            let agenda = item.idAgenda;
            let agendaObj = this.agendaOptions.find(e => e.id == agenda);
            if (agendaObj) {
                returnValue = agendaObj.descrizione;
            }
            return returnValue.toUpperCase()
        },


        loadReasonId() {
            let link = process.env.VUE_APP_PATH_API + "/saccsarrlazio/integrazionenre/" + this.presidio.codiceStruttura + "/reasons"
            axios.get(link).then((response) => {
                this.reasonIdOptions = response.data.data;

            }).catch((erro) => erro);
        },
        loadStausOrder() {
            let link = process.env.VUE_APP_PATH_API + "/saccsarrlazio/integrazionenre/" + this.presidio.codiceStruttura + "/state"
            axios.get(link).then((response) => {
                this.orderStutusOptions = response.data.data;
            }).catch((erro) => erro);
        },

        onChangeStatoPrenotazione(item) {
            this.appuntamentoSel = item;
            this.$refs.mdlChangeStato.show();
        },
        onHide() {
            this.appuntamentoSel = null;
        },
        onChangeSelectStato(params) {
            if (params == 'PRENOTATO' || params == "ACCETTATO" || params == "EROGATO") {
                this.jsonData.reasonId = 0;
            }
        },
        onCambiaStato() {
            console.log(this.appuntamentoSel);


            let request = {
                orderId: Number(this.appuntamentoSel.note),
                orderStatus: this.jsonData.orderStatus,
                reasonId: Number(this.jsonData.reasonId)
            }
            console.log(request);
            this.openShowModalLoading()
            let link = process.env.VUE_APP_PATH_API + "/saccsarrlazio/cambiostato/" + this.presidio.codiceStruttura
            axios.put(link, request).then((response) => {
                console.log(response);
                this.closeShowModalLoading();
                toast.success(response.data.messaggio);
                this.$refs.mdlChangeStato.hide();
                this.loadData();
            }).catch((erro) => {
                erro;
                this.closeShowModalLoading();
            }

            );
        }


    },
};
</script>

<style scoped>
.ft-wrapper-ricetta {
    margin-bottom: 16px;
}

.ft-ricetta-titolo {
    font-weight: 600;
    display: block;
    margin-bottom: 8px;
}

/* Prestazioni orizzontali */
.ft-wrapper-prestazioni {
    display: flex;

    gap: 16px;
}

.ft-prestazione-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #f9f9f9;
}

.ft-prestazione-codice {
    font-weight: 600;
    margin-bottom: 6px;
}

.ft-prestazione-badge-container {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
}

.ft-badge {
    min-width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: white;
    font-weight: 600;
}

.ft-badge-complete {
    background-color: #00a3ff;
}

.ft-badge-incomplete {
    background-color: #ffc107;
}

.ft-badge-total {
    background-color: #00a3ff;
}

.sa-badge-internal {
    border-radius: 5px;
    border-left: 4px solid var(--bg-sidebar-item);
    border-top: 1px solid var(--bg-main-nav-bar);
    border-bottom: 1px solid var(--bg-main-nav-bar);
    border-right: 1px solid var(--bg-main-nav-bar);
    padding: 7px !important;
    margin-bottom: 5px;
    max-width: max-content;
}

.sa-badge {
    width: 100%;
    max-width: none !important;
}
</style>
